import { useDispatch, useSelector } from 'react-redux';
import { ExportType, Values } from '../interfaces';
import {
  confirmPayout,
  exportPayoutDetail,
  exportPayouts,
  getPayoutFee,
  getRequiredFields,
  getBanks,
  validatePartialPayout,
  getPayoutDetail,
  getPayouts,
  resetCreatePayout,
  sendRequestPayout,
  setCreatePayoutData,
  setCreatePayoutStep,
  setCreatePayoutSubView,
  setPayoutDetail,
  startCreatePayout,
  showExportPayouts,
  verifyOtpConfigured,
} from './actions';
import { PayoutsSelectors } from './selectors';
import { CreatePayoutData, Filters, FlowType, Payout, PayoutCreationStep } from './interfaces';

export const usePayouts = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(PayoutsSelectors.getLoading),
    error: useSelector(PayoutsSelectors.getError),
    allPayouts: useSelector(PayoutsSelectors.getAllPayouts),
    requestPayout: useSelector(PayoutsSelectors.getRequestPayout),
    export: useSelector(PayoutsSelectors.getExport),
    exportType: useSelector(PayoutsSelectors.getExportType),
    createPayout: useSelector(PayoutsSelectors.getCreatePayout),
    isOtpConfigured: useSelector(PayoutsSelectors.getVerifyOtpConfigured),
    getPayouts: (page?: number, filter?: Filters) => dispatch(getPayouts(page, filter)),
    getBanks: (country: string) => dispatch(getBanks(country)),
    sendRequestPayout: (values: Values) => dispatch(sendRequestPayout(values)),
    setPayoutDetail: (data: Payout) => dispatch(setPayoutDetail(data)),
    getPayoutDetail: (id: number) => dispatch(getPayoutDetail(id)),
    exportPayoutDetail: (id: number) => dispatch(exportPayoutDetail(id)),
    payoutDetail: useSelector(PayoutsSelectors.getPayoutDetail),
    showExportPayouts: (show: boolean) => dispatch(showExportPayouts(show)),
    exportPayouts: (filter: string, type: ExportType) => dispatch(exportPayouts(filter, type)),
    startCreatePayout: () => dispatch(startCreatePayout()),
    setCreatePayoutStep: (step: PayoutCreationStep) => dispatch(setCreatePayoutStep(step)),
    setCreatePayoutSubView: (subView: 'country' | 'bank-data') => dispatch(setCreatePayoutSubView(subView)),
    setCreatePayoutData: (data: Partial<CreatePayoutData> & { bankOptions?: Array<{ code: string; name: string }> }) =>
      dispatch(setCreatePayoutData(data)),
    getRequiredFields: (country: string, flowType: FlowType) => dispatch(getRequiredFields(country, flowType)),
    getPayoutFee: (amount: number, currency: string, country: string) => dispatch(getPayoutFee(amount, currency, country)),
    validatePartialPayout: (values: Record<string, string | number>) => dispatch(validatePartialPayout(values)),
    confirmPayout: (otpCode: string) => dispatch(confirmPayout(otpCode)),
    resetCreatePayout: () => dispatch(resetCreatePayout()),
    verifyOtpConfigured: () => dispatch(verifyOtpConfigured()),
  };
};
